import { render, staticRenderFns } from "./Ask.vue?vue&type=template&id=49623db2&"
import script from "./Ask.vue?vue&type=script&lang=js&"
export * from "./Ask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/casperjureskog/CMM/creo-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49623db2')) {
      api.createRecord('49623db2', component.options)
    } else {
      api.reload('49623db2', component.options)
    }
    module.hot.accept("./Ask.vue?vue&type=template&id=49623db2&", function () {
      api.rerender('49623db2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/asset/sidebar/Ask.vue"
export default component.exports